import React from "react";
import { Link, useHistory } from 'react-router-dom';
import {
  img_package_classic,
  img_package_fresh,
  sprite_ring_text_range,
} from '../../assets/imgs';
import { FormattedMessage } from "react-intl";

const ProductRange = () => {
  const history = useHistory();

  const redirectTo = (url) => {
    history.push(url);
   
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }
  return (
    <section className="product-range">
    <div className="product-range-wrapper">
      <h3>
        <em>
          <FormattedMessage id="product_range.block_title" defaultMessage="Find the perfect <span>ACUVUE® Define®</span> for you"
            values={{ span: msg =>  <span> {msg} </span>  }}
          />
        </em>
      </h3>
      <div className="product-stack classic">
        <img src={img_package_classic} alt="Acuvue Define® Classic" />

        <a onClick={() => redirectTo('/define-classic')} className="discover-btn tertiary">
          <FormattedMessage id="product_range.button.classic" defaultMessage="Discover Define® Classic" />
          <div className="arrow btn-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 40 12"
              fill="none"
            >
              <path d="M10.2 1C10.2 3.8 12.4 6 15.2 6C12.4 6 10.2 8.2 10.2 11M0.800049 6H15.3M34.2001 1C34.2001 3.8 36.4001 6 39.2001 6C36.4001 6 34.2001 8.2 34.2001 11M24.8 6H39.3"></path>
            </svg>
          </div>
        </a>
      </div>
      <div className="product-stack fresh">
        <img src={img_package_fresh} alt="Acuvue Define® Fresh" />
        <a onClick={() => redirectTo('/define-fresh')} className="discover-btn tertiary">
          <FormattedMessage id="product_range.button.fresh" defaultMessage="Discover Define® Fresh" />
          <div className="arrow btn-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 40 12"
              fill="none"
            >
              <path d="M10.2 1C10.2 3.8 12.4 6 15.2 6C12.4 6 10.2 8.2 10.2 11M0.800049 6H15.3M34.2001 1C34.2001 3.8 36.4001 6 39.2001 6C36.4001 6 34.2001 8.2 34.2001 11M24.8 6H39.3" />
            </svg>
          </div>
        </a>
      </div>
      <div className="decoration">
        <img src={sprite_ring_text_range} />
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 13">
          <path
            d="M6.00013 6.33203C3.91573 6.33203 2.14581 7.67961 1.51545 9.55178C1.2528 10.3306 2.00153 11.0794 2.78038 10.8167C4.65186 10.1863 6.00013 8.41643 6.00013 6.33203Z"
            fill="#004EEC"
          />
          <path
            d="M6 6.33203C6 8.41643 7.34757 10.1863 9.21975 10.8167C9.9986 11.0794 10.7473 10.3306 10.4847 9.55178C9.85432 7.68031 8.0844 6.33203 6 6.33203Z"
            fill="#004EEC"
          />
          <path
            d="M6.00013 6.33216C6.00013 4.24776 4.65256 2.47785 2.78038 1.84748C2.00153 1.58483 1.2528 2.33356 1.51545 3.11241C2.14581 4.98389 3.91573 6.33216 6.00013 6.33216Z"
            fill="#004EEC"
          />
          <path
            d="M6 6.33216C8.0844 6.33216 9.85432 4.98459 10.4847 3.11241C10.7473 2.33356 9.9986 1.58483 9.21975 1.84748C7.34828 2.47785 6 4.24776 6 6.33216Z"
            fill="#004EEC"
          />
          <path
            d="M5.99991 6.33203C4.52626 7.80568 4.22789 10.0105 5.1055 11.7798C5.47041 12.5159 6.52942 12.5159 6.89433 11.7798C7.77193 10.0105 7.47356 7.80568 5.99991 6.33203Z"
            fill="#004EEC"
          />
          <path
            d="M6 6.33194C7.47365 7.80559 9.67851 8.10396 11.4477 7.22636C12.1839 6.86145 12.1839 5.80244 11.4477 5.43753C9.67851 4.55992 7.47365 4.8583 6 6.33194Z"
            fill="#004EEC"
          />
          <path
            d="M5.99983 6.33194C4.52618 4.8583 2.32131 4.55992 0.552092 5.43753C-0.184031 5.80244 -0.184031 6.86145 0.552092 7.22636C2.32131 8.10396 4.52618 7.80559 5.99983 6.33194Z"
            fill="#004EEC"
          />
          <path
            d="M5.99991 6.33234C7.47356 4.8587 7.77193 2.65383 6.89433 0.884612C6.52942 0.148489 5.47041 0.148489 5.1055 0.884612C4.22789 2.65383 4.52626 4.8587 5.99991 6.33234Z"
            fill="#004EEC"
          />
        </svg>
      </div>
    </div>
  </section>
  );
};

export default ProductRange;
